import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect, useState } from "react";

export default function CateringCTASection() {
  const { ref, inView } = useInView({
    triggerOnce: true, // animacja tylko raz
    threshold: 0.3,     // 30% elementu musi być widoczne
  });

  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (inView) {
      setHasAnimated(true);
    }
  }, [inView]);

  return (
    <section id="catering"
      ref={ref}
      className="max-w-7xl mx-auto relative bg-cover bg-center bg-no-repeat text-white min-h-[500px] flex items-center justify-center px-4 rounded-xl"
      style={{ backgroundImage: "url('/images/foto14.jpg')" }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 z-0 rounded-xl"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl text-center py-20 rounded-xl">
        <motion.h2
          initial={{ x: -100, opacity: 0 }}
          animate={hasAnimated ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0 }}
          className="text-4xl md:text-5xl font-heading font-semibold leading-tight mb-6"
        >
          Niezapomniany catering<br /> na każdą okazję
        </motion.h2>

        <motion.p
          initial={{ x: -100, opacity: 0 }}
          animate={hasAnimated ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-lg md:text-xl mb-8 text-white/80"
        >
          Niezależnie czy planujesz kameralne spotkanie, czy wielką uroczystość – zadbamy o Twój smak i wyjątkową oprawę.
        </motion.p>

        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={hasAnimated ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <Link
            to="/menu"
            className="inline-block bg-accent text-white px-8 py-3 text-base rounded-full font-semibold shadow-md hover:bg-primary transition"
          >
            Zobacz menu
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
